export default [
    {
        path: '/operator-workspace/driver',
        name: 'WorkspaceDriver',
        component: () => import('../../components/operator-workspace/WorkspaceDriver.vue'),
        meta: { requiresAuth: true, title: 'Карточка водителя', activeSideIcon: '#icon-drive' },
    },
    {
        path: '/operator-workspace',
        name: 'OperatorWorkspace',
        component: () => import('../../components/operator-workspace/OperatorWorkspace.vue'),
        meta: { requiresAuth: true, title: 'Рабочее место оператора', activeSideIcon: '#icon-chat' },
    },
    {
        path: '/(uk/|ru/)?/icons',
        name: 'allIcons',
        component: () => import('../views/allIcons'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-bill',
            title: 'icons'
        },
    }, {
        path: '*',
        component: () => import('../views/NotFound'),
        query: true,
        meta: {
            requiresAuth: true,
            title: '404'
        }
    }, {
        path: '/(uk/|ru/)?/',
        component: () => import('../views/dashboard/overview-v2/Index'),
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-dashboard',
            title: 'dashboard'
        }
    }, {
        path: '/(uk/|ru/)?/dashboard',
        name: 'dashboard',
        component: () => import('../views/dashboard/overview-v2/Index'),
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-dashboard',
            title: 'dashboard'
        }
    }, {
        path: '/(uk/|ru/)?/login',
        name: 'login',
        component: () => import('../views/login/Login'),
        beforeEnter: (to, from, next) => {
            window.temphref =  window.temphref || location.pathname + location.search
            next();
        },
        meta: {
            title: 'Вход'
        }
    }, {
        path: '/(uk/|ru/)?/restore',
        name: 'restore',
        component: () => import('../views/login/Restore'),
        meta: {
            title: 'Восстановление пароля',
            requiresAuth: false,
        }
    },
]
